export const Services = () => {
  const services = [
    {
      title: "Web Application Development",
      desc: "We build scalable, secure, and high-performance web applications using modern technologies like React, Node.js, and MongoDB. From startups to enterprise solutions, we deliver real-world production-ready systems."
    },
    {
      title: "Mobile App Development",
      desc: "We create Android and iOS mobile applications with smooth UI, fast performance, and real-time features. Our apps are designed for user engagement and business growth."
    },
    {
      title: "UI/UX Design",
      desc: "We design intuitive, modern, and user-friendly interfaces that improve user experience and increase product success. Every design is crafted with usability and aesthetics."
    },
    {
      title: "AI & Machine Learning",
      desc: "We integrate intelligent systems like prediction models, automation, chatbots, and data analytics to make your applications smarter and more efficient."
    },
    {
      title: "IoT Development",
      desc: "We build IoT-based systems that connect devices, collect real-time data, and automate operations for industries, agriculture, and smart systems."
    },
  ];

  return (
    <section className="py-14">
      <h2 className="text-4xl font-bold text-center mb-14">Our Services</h2>

      <div className="max-w-7xl w-full mx-auto grid md:grid-cols-3 gap-8">
        {services.map((s, i) => (
          <div key={i} className="p-8 border rounded-2xl hover:shadow-xl transition">
            <h3 className="text-xl font-semibold mb-4">{s.title}</h3>
            <p className="text-gray-600 leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};